var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_15826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05033 3.05025C2.75744 3.34315 2.75744 3.81802 3.05033 4.11091L6.93942 8L3.05033 11.8891C2.75744 12.182 2.75744 12.6569 3.05033 12.9497C3.34323 13.2426 3.8181 13.2426 4.11099 12.9497L8.00008 9.06066L11.8892 12.9497C12.1821 13.2426 12.6569 13.2426 12.9498 12.9497C13.2427 12.6569 13.2427 12.182 12.9498 11.8891L9.06074 8L12.9498 4.11091C13.2427 3.81802 13.2427 3.34315 12.9498 3.05025C12.6569 2.75736 12.1821 2.75736 11.8892 3.05025L8.00008 6.93934L4.11099 3.05025C3.8181 2.75736 3.34323 2.75736 3.05033 3.05025Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_15826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.cbb1a1f28883ebc2068038112f774274.svg";
export { ForwardRef as ReactComponent };